class BaseTool {
  constructor (mapHelper, data) {
    this.mapHelper = mapHelper
    this.data = data
  }

  getMap () {
    return this.mapHelper.map
  }

  update (data) {
    this.data = data
  }

  destroy () {

  }
}

export default BaseTool
